import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { PrimeReactProvider } from 'primereact/api';
import './style.css'
import "primereact/resources/themes/tailwind-light/theme.css";
import 'primeicons/primeicons.css';


ReactDOM.createRoot(document.getElementById('app')!).render(
  <React.StrictMode>
    <PrimeReactProvider>
      <App />
    </PrimeReactProvider>
  </React.StrictMode>,
)

